/**
 * Footer Accordions
 * Gerencia accordions no footer com comportamento responsivo
 */

export class FooterAccordions {
    constructor(options = {}) {
        this.options = {
            selector: '.footerContent__info:not(:has(.storeOpeningHours)) details',
            desktopBreakpoint: 1024,
            openDesktopByDefault: true,
            ...options
        };
        
        this.details = [];
        this.resizeTimeout = null;
        this.init();
    }

    init() {
        this.details = document.querySelectorAll(this.options.selector);
        
        if (this.details.length === 0) {
            console.warn('FooterAccordions: Nenhum elemento encontrado');
            return;
        }
        
        this.setupDetails();
        this.attachResizeListener();
    }

    setupDetails() {
        this.details.forEach(detail => {
            const summary = detail.querySelector('summary');
            
            if (summary) {
                // Abrir por padrão em desktop
                if (this.options.openDesktopByDefault && window.innerWidth >= this.options.desktopBreakpoint) {
                    detail.setAttribute('open', '');
                }
                
                // Evento de clique
                summary.addEventListener('click', (e) => {
                    this.handleSummaryClick(e, detail);
                });
            }
        });
    }

    handleSummaryClick(event, detail) {
        // Prevenir comportamento padrão em desktop
        if (window.innerWidth >= this.options.desktopBreakpoint) {
            event.preventDefault();
            return false;
        }
    }

    attachResizeListener() {
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            
            this.resizeTimeout = setTimeout(() => {
                this.handleResize();
            }, 150);
        });
    }

    handleResize() {
        if (window.innerWidth >= this.options.desktopBreakpoint) {
            // Desktop: abrir todos
            if (this.options.openDesktopByDefault) {
                this.details.forEach(detail => {
                    detail.setAttribute('open', '');
                });
            }
        } else {
            // Mobile: fechar todos
            this.details.forEach(detail => {
                detail.removeAttribute('open');
            });
        }
    }

    destroy() {
        window.removeEventListener('resize', () => this.handleResize());
    }
}

export default FooterAccordions;
